import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { UserDto } from '@/types/dtos/user/response/user.dto';

export const GET_USER_QUERY_KEY = 'get-user';

export function isGlobalAdminUser(user: UserDto | undefined): boolean {
  return user?.globalRoles?.includes('admin') ?? false;
}

export const useGetUserQuery = () => {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  return useQuery({
    queryKey: [GET_USER_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return getUser(token ?? '');
    },
    enabled: isLoaded && Boolean(isSignedIn),
  });
};

const getUser = async (token: string): Promise<UserDto> => {
  const url = `${import.meta.env.VITE_API_URL}/users`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
